import React, { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Button,
  Collapse,
  ListItem,
  Typography,
  makeStyles
} from '@material-ui/core';
import { Icon } from '@iconify/react';
import { Box } from '@mui/material';
import Rules from 'src/Rules.json'
const useStyles = makeStyles(theme => ({
  item: {
    display: 'block',
    paddingTop: 0,
    paddingBottom: 0
  },
  itemLeaf: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: theme.palette.text.secondary,
    padding: '6px 6px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%'
  },
  buttonLeaf: {
    color: theme.palette.text.secondary,
    padding: '6px 6px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover': {
      backgroundColor:Rules.nav_top_bar.navbar_items_hover_color
    },
    '&.depth-0': {
      '& $title': {
        // fontWeight: theme.typography.fontWeightMedium
      }
    }
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(3)
  },
  title: {
    marginRight: 'auto'
  },
  active: {
    color: theme.palette.secondary.main,
    '& $title': {
      // fontWeight: theme.typography.fontWeightMedium
    },
    '& $icon': {
      color: theme.palette.secondary.main
    },
    backgroundColor:Rules.nav_top_bar.navbar_items_hover_color
  }
}));

const NavItem = ({
  children,
  className,
  depth,
  href,
  icon: NavIcon,
  info: Info,
  open: openProp,
  navOpen,
  title,  handleDrawer,

  ...rest
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = { paddingLeft };

  if (children) {
    return (
    <>
      <ListItem
        className={clsx(classes.item, className)}
        disableGutters
        key={title}
        {...rest}
      >
        <Button className={classes.button} onClick={handleToggle} style={style}>
          {NavIcon && (
            <Icon
              icon={NavIcon}
              style={{
                color:'#ffffff',                fontSize: '25px',
                marginRight: '10px',
                marginBottom: '2px'
              }}
            />
          )}
          <Typography variant="body2" style={{ color: '#ffffff' }} className={classes.title} sx={{ opacity: navOpen ? 1 : 0 }}>
            {title}
          </Typography>
          {open ? (
            <Icon
              icon="material-symbols-light:expand-less-rounded"
              style={{
                fontSize: '25px',
                marginRight: '10px',
                marginBottom: '2px',
                color: '#ffffff'
              }}
            />
          ) : (
            <Icon
              icon="material-symbols-light:expand-more-rounded"
              style={{
                fontSize: '25px',
                marginRight: '10px',
                marginBottom: '2px',
                color: '#ffffff'
              }}
            />
          )}
        </Button>

        <Collapse in={open}>{children}</Collapse>
      </ListItem>
      <Box mt={0.2}/>
</>
    );
  }

  return (
    <>
    <ListItem
      className={clsx(classes.itemLeaf, className)}
      disableGutters
      key={title}
      {...rest}
    >
      <Button
        activeClassName={classes.active}
        className={clsx(classes.buttonLeaf, `depth-${depth}`)}
        component={RouterLink}
        style={style}
        to={href}
      >
        {NavIcon && (
          <Icon
            icon={NavIcon}
            style={{
              color:'#ffffff',              fontSize: '25px',
              marginRight: '10px',
              marginBottom: '2px'
            }}
          />
        )}
        <Typography variant="body2" style={{ color: '#ffffff' }} className={classes.title} sx={{ opacity: navOpen ? 1 : 0 }}>
          {title}
        </Typography>
        {Info && <Info />}
      </Button>
    </ListItem>
    <Box mt={0.3}/>
</>
  );
};

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  info: PropTypes.elementType,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired
};
NavItem.defaultProps = {
  open: false
};

export default NavItem;